<template>
  <div class="relative">

      <div @click.prevent="hideScaledPhoto" class="hidden w-[100%] h-[100%] absolute z-50 hidden items-center justify-center hover:cursor-pointer" id="scaled_image" style="background-color: rgba(0,0,0,.4)">
          <img src="" alt="" id="scaled_image_src" class="scaled-image w-[100%] h-[100%] object-contain">
      </div>

    <Head :title="`Girl #${form.girl.id}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/girls">Girls</Link>
        <span class="text-indigo-400 font-medium">/</span>
        Girl #{{ form.girl.id }} / {{ form.girl.is_moderated ? '✅' : '⛔️' }}
      </h1>
    </div>
      <div class="max-w-full bg-white rounded-md shadow overflow-hidden">

          <div class="flex w-full">
              <div class="px-[15px] py-[10px] border-r-2 border-b-2 border-gray-100 w-[40%]">
                  <div class="font-bold mb-[8px]">Names</div>
                  <div>{{form.girl.names}}</div>
              </div>
              <div class="px-[15px] py-[10px] border-r-2 border-b-2 border-gray-100 w-[20%]">
                  <div class="font-bold mb-[8px]">Nickname</div>
                  <div>{{form.girl.nickname}}</div>
              </div>
              <div class="px-[15px] py-[10px] border-r-2 border-b-2 border-gray-100 w-[10%]">
                  <div class="font-bold mb-[8px]">Distance</div>
                  <div>{{form.girl.distance}}</div>
              </div>
              <div class="px-[15px] py-[10px] border-r-2 border-b-2 border-gray-100 w-[10%]">
                  <div class="font-bold mb-[8px]">Age</div>
                  <div>{{form.girl.age}}</div>
              </div>
              <div class="px-[15px] py-[10px] border-r-2 border-b-2 border-gray-100 w-[10%]">
                  <div class="font-bold mb-[8px]">Visits</div>
                  <div>{{form.girl.visits}}</div>
              </div>
              <div class="px-[15px] py-[10px] border-b-2 border-gray-100 w-[10%]">
                  <div class="font-bold mb-[8px]">Likes</div>
                  <div>{{form.girl.likes}}</div>
              </div>
          </div>

          <div class="flex w-full mb-[20px]">
              <div class="px-[15px] py-[10px] border-r-2 border-b-2 border-gray-100 w-[25%]">
                  <div class="font-bold mb-[8px]">Category</div>
                  <div v-if="form.girl.sub_category === null">
                      Empty
                  </div>
                  <div v-if="form.girl.sub_category != null" class="flex flex-wrap">
                      <div v-for="category in form.girl.sub_category" class="mr-[5px] mb-[5px] text-[12px] font-bold text-center inline-block rounded-lg py-[6px] px-[10px] bg-blue-600 text-white">
                          {{category}}
                      </div>
                  </div>
              </div>
              <div class="px-[15px] py-[10px] border-r-2 border-b-2 border-gray-100 w-[25%]">
                  <div class="font-bold mb-[8px]">Age group</div>
                  <div v-if="form.girl.age_group === null">
                      Empty
                  </div>
                  <div v-if="form.girl.age_group != null" class="flex flex-wrap">
                      <div v-for="age in form.girl.age_group" class="mr-[5px] mb-[5px] text-[12px] font-bold text-center inline-block rounded-lg py-[6px] px-[10px] bg-blue-600 text-white">
                          {{age}}
                      </div>
                  </div>
              </div>
              <div class="px-[15px] py-[10px] border-b-2 border-gray-100 w-[50%]">
                  <div class="font-bold mb-[8px]">Country</div>
                  <div v-if="form.girl.country === null">
                      Empty
                  </div>
                  <div v-if="form.girl.country != null" class="flex flex-wrap">
                      <div v-for="country in form.girl.country" class="mr-[5px] mb-[5px] text-[12px] font-bold text-center inline-block rounded-lg py-[6px] px-[10px] bg-blue-600 text-white">
                          {{country}}
                      </div>
                  </div>
              </div>
          </div>

          <div v-if="form.girl.is_moderated === true">

<!--              <div class="w-full font-bold text-[20px] mb-[10px] px-[15px]">Profile pictures</div>-->

<!--              <div v-if="form.girl.profile_pictures.length === 0" class="px-[15px] mb-[10px]">-->
<!--                  No photos-->
<!--              </div>-->

<!--              <div v-if="form.girl.profile_pictures.length > 0">-->
<!--                  <div class="flex flex-wrap w-full px-[15px]">-->
<!--                      <div v-for="photo in form.girl.profile_pictures" class="mb-3 mr-3">-->
<!--                          <div class="h-[140px]">-->
<!--                              <img :src="photo" alt="" class=" hover:cursor-pointer inline-block w-full h-full object-contain">-->
<!--                          </div>-->
<!--                      </div>-->
<!--                  </div>-->
<!--              </div>-->

              <div class="w-full font-bold text-[20px] mb-[10px] px-[15px]">Photos by categories</div>
              <div class="w-full font-bold text-[16px] mb-[10px] px-[15px]">Normal</div>

              <div v-if="form.girl.no_nudes.length === 0" class="px-[15px] mb-[10px]">
                  No photos
              </div>

              <div v-if="form.girl.no_nudes.length > 0">
                  <div class="flex flex-wrap w-full px-[15px]">
                      <div v-for="photo in form.girl.no_nudes" class="mb-3 mr-3">
                          <div class="h-[140px] relative" :class="{'border-2 border-green-500': form.girl.profile_pictures.includes(photo)}">
                              <span v-if="form.girl.profile_pictures.includes(photo)" class="absolute z-50 inline-block bg-green-500 text-[12px] font-bold text-center text-white py-[3px] px-[5px]">ProfilBild</span>
                              <img :src="photo" alt="" class=" hover:cursor-pointer inline-block w-full h-full object-contain">
                          </div>
                      </div>
                  </div>
              </div>

              <div class="w-full font-bold text-[16px] mb-[10px] px-[15px]">FSK18</div>

              <div v-if="form.girl.adult.length === 0" class="px-[15px] mb-[10px]">
                  No photos
              </div>

              <div v-if="form.girl.adult.length > 0">
                  <div class="flex flex-wrap w-full px-[15px]">
                      <div v-for="photo in form.girl.adult" class="mb-3 mr-3">
                          <div class="h-[140px] relative" :class="{'border-2 border-green-500': form.girl.profile_pictures.includes(photo)}">
                              <span v-if="form.girl.profile_pictures.includes(photo)" class="absolute z-50 inline-block bg-green-500 text-[12px] font-bold text-center text-white py-[3px] px-[5px]">ProfilBild</span>
                              <img :src="photo" alt="" class=" hover:cursor-pointer inline-block w-full h-full object-contain">
                          </div>
                      </div>
                  </div>
              </div>

              <div class="w-full font-bold text-[16px] mb-[10px] px-[15px]">Brust erkennbar</div>

              <div v-if="form.girl.boobs.length === 0" class="px-[15px] mb-[10px]">
                  No photos
              </div>

              <div v-if="form.girl.boobs.length > 0">
                  <div class="flex flex-wrap w-full px-[15px]">
                      <div v-for="photo in form.girl.boobs" class="mb-3 mr-3">
                          <div class="h-[140px] relative" :class="{'border-2 border-green-500': form.girl.profile_pictures.includes(photo)}">
                              <span v-if="form.girl.profile_pictures.includes(photo)" class="absolute z-50 inline-block bg-green-500 text-[12px] font-bold text-center text-white py-[3px] px-[5px]">ProfilBild</span>
                              <img :src="photo" alt="" class=" hover:cursor-pointer inline-block w-full h-full object-contain">
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div v-if="form.girl.is_moderated === false">
              <div class="w-full font-bold text-[16px] mb-[10px] px-[15px]">Photos</div>

              <div class="flex flex-wrap w-full px-[15px]">
                  <div v-for="(photo, key) in form.girl.all_photos" class="mb-3 mr-3">
                      <div class="h-[140px]">
                          <img :src="photo" @click.prevent="scalePhoto(key)" alt="" :class="'hover:cursor-pointer inline-block w-full h-full object-contain photo-image-'+key">
                      </div>
                  </div>
              </div>
          </div>

          <div class="w-full text-center py-[20px]">
              <Link class="inline-block px-[25px] py-[10px] font-bold text-white bg-blue-600 rounded-lg" :href="'/profile-moderation?girl_id=' + form.girl.id" target="_blank">Moderate</Link>
          </div>
      </div>
      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">Chats</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                  <table class="w-full whitespace-nowrap">
                      <tr class="text-left font-bold">
                          <th class="pb-4 pt-6 px-6">ID</th>
                          <th class="pb-4 pt-6 px-6">Customer ID</th>
                          <th class="pb-4 pt-6 px-6">Unread messages</th>
                          <th class="pb-4 pt-6 px-6">Customer last activity</th>
                          <th class="pb-4 pt-6 px-6" colspan="2">Last message</th>
                      </tr>
                      <tr v-for="chat in chats" :key="chat.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{ chat.id }}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{chat.customer.firstname}} {{chat.customer.lastname}} ({{ chat.customer.id }})
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{chat.unread_messages_count}}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{chat.customer.last_activity}}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{ chat.last_message ? chat.last_message.text : 'no last message' }}
                              </Link>
                          </td>
                      </tr>
                      <tr v-if="chats.length === 0">
                          <td class="px-6 py-4 border-t" colspan="5">No chats found.</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>

      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">List of customers who liked this girl</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                  <table class="w-full whitespace-nowrap">
                      <tr class="text-left font-bold">
                          <th class="pb-4 pt-6 px-6">ID</th>
                          <th class="pb-4 pt-6 px-6">Customer ID</th>
                          <th class="pb-4 pt-6 px-6">Like time</th>
                      </tr>
                      <tr v-for="like in likesFromCustomer" :key="like.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ like.id }}
                              </div>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/customers/${like.customer.id}/edit`">
                                  {{like.customer.firstname}} {{like.customer.lastname}} ({{ like.customer.id }})
                              </Link>
                          </td>
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ this.formatDate(like.created_at) }}
                              </div>
                          </td>
                      </tr>
                      <tr v-if="likesFromCustomer.length === 0">
                          <td class="px-6 py-4 border-t" colspan="5">No Likes found.</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>

      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">List of customers who have been liked by the girl</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                  <table class="w-full whitespace-nowrap">
                      <tr class="text-left font-bold">
                          <th class="pb-4 pt-6 px-6">ID</th>
                          <th class="pb-4 pt-6 px-6">Customer ID</th>
                          <th class="pb-4 pt-6 px-6">Like time</th>
                      </tr>
                      <tr v-for="like in likesToCustomer" :key="like.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ like.id }}
                              </div>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/customers/${like.customer.id}/edit`">
                                  {{like.customer.firstname}} {{like.customer.lastname}} ({{ like.customer.id }})
                              </Link>
                          </td>
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ this.formatDate(like.created_at) }}
                              </div>
                          </td>
                      </tr>
                      <tr v-if="likesToCustomer.length === 0">
                          <td class="px-6 py-4 border-t" colspan="5">No Likes found.</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>

      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">List of customers attached to the girl</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                  <table class="w-full whitespace-nowrap">
                      <tr class="text-left font-bold">
                          <th class="pb-4 pt-6 px-6">ID</th>
                          <th class="pb-4 pt-6 px-6">Customer ID</th>
                          <th class="pb-4 pt-6 px-6">Like/Dislike customer</th>
                      </tr>
                      <tr v-for="customer in customerCollection" :key="customer.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ customer.id }}
                              </div>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/customers/${customer.id}/edit`">
                                  {{customer.first_name}} {{customer.last_name}} ({{ customer.id }})
                              </Link>
                          </td>
                          <td class="border-t">
                              <a href="#" :data-id="customer.id" @click="likeCustomerProfile" class="inline-block rounded-lg border border-gray-300 ml-6 mr-4 px-5 py-3 hover:bg-gray-600 hover:text-white">Like ❤️</a>
                              <a href="#" :data-id="customer.id" @click="dislikeCustomerProfile" class="inline-block rounded-lg border bg-black text-white border-gray-300 px-5 py-3 hover:bg-black-600">Dislike 💔️</a>
                          </td>
                      </tr>
                      <tr v-if="customerCollection.length === 0">
                          <td class="px-6 py-4 border-t" colspan="5">No Customers attached.</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import moment from "moment";

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
      girl: Object,
      chats: Array,
      likesFromCustomer: Array,
      likesToCustomer: Array,
      customerCollection: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        girl: this.girl
      }),
    }
  },
  methods: {
      scalePhoto(key){
          let photoItem = document.getElementsByClassName('photo-image-' + key)[0];

          let blockToShow = document.getElementById("scaled_image");
          let imgToShow = document.getElementById("scaled_image_src");

          imgToShow.src = photoItem.src;
          blockToShow.classList.remove("hidden");
          blockToShow.classList.add("inline-block");
      },
      hideScaledPhoto(){
          let blockToShow = document.getElementById("scaled_image");
          let imgToShow = document.getElementById("scaled_image_src");
          imgToShow.src = '';
          blockToShow.classList.add("hidden");
          blockToShow.classList.remove("inline-block");
      },
      formatDate(value) {
          const date = moment.unix(value).utc();
          return date.format("YYYY-MM-DD HH:mm:ss")
      },
      likeCustomerProfile: function(event){

          axios.post(`/customers/${event.target.dataset.id}/like`, {
              girlId: this.girl.id,
          })
              .then(function (response) {
                  //console.log(response);
                  window.location.reload();
              })
              .catch(function (error) {
                  console.log('error');
              });
      },
      dislikeCustomerProfile: function(event){

          axios.post(`/customers/${event.target.dataset.id}/dislike`, {
              girlId: this.girl.id,
          })
              .then(function (response) {
                  //console.log(response);
                  window.location.reload();
              })
              .catch(function (error) {
                  console.log('error');
              });
      },
  },
}
</script>
